// HELPERS
export const PHONE_HELPER = "Telefone Inválido";
export const DOCUMENT_HELPER = "Documento Inválido";
export const STRING_NOT_NULL_HELPER = "Valor Necessário";
export const EMAIL_VALIDATOR_HELPER = "E-mail inválido";
export const NFCE_CSC_HELPER =
  "Sem este campo não será possível emitir NFCe em produção. Veja com o SEFAZ do seu estado como gerar este código.";
export const NFCE_CSC_ID_HELPER =
  "ID do CSC para emissão de NFCe em ambiente de produção. Sem este campo não será possível emitir NFCe em produção.Veja com o SEFAZ do seu estado como gerar este número.";

// ERRORS
export const ERROR_REQUIRED_FIELDS = "Preencha todos os campos obrigatórios *";
export const ERROR_NFCE_CSC = "Código CSC inválido";
export const ERROR_NFCE_CSC_ID = "ID CSC";
export const ERROR_MESSAGE = "Ocorreu um erro inesperado";
export const ERROR_MESSAGE_ORDER_STATUS_CHANGE =
  "Não foi possível atualizar o status do pedido, tente novamente em 1 minuto";
export const ERROR_MESSAGE_SUPPORT =
  "Ocorreu um erro inesperado, favor contatar o suporte";
export const ERROR_MESSAGE_ADDRESS_NOT_FOUND =
  "Não conseguimos encontrar o endereço informado, todos os campos estão preenchidos?";
export const ERROR_QZ_TRAY_REQUIRED =
  "Para conseguir imprimir abra programa QZ TRAY no seu computador!";
